import Navbar from "../components/Login/Navbar/Navbar2";
import RoomBody from "../components/Rooms/Roombody";

const Rooms = () => {
    return(
        <>
            <Navbar />
            <RoomBody />
        </>
    )
}

export default Rooms;